import { useState } from 'react';
import type { DayRange } from '../../data/usage-data.ts';

const DAY_MS = 86_400_000;

type Preset = 'this-month' | 'last-month' | '7' | '30' | '90' | 'custom';

const PRESETS: ReadonlyArray<{ value: Preset; label: string }> = [
  { value: 'this-month', label: 'This month' },
  { value: 'last-month', label: 'Last month' },
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
  { value: 'custom', label: 'Custom range' },
];

export function presetRange(preset: Exclude<Preset, 'custom'>, today = new Date()): DayRange {
  const day = (at: Date) => at.toISOString().slice(0, 10);
  const year = today.getUTCFullYear();
  const month = today.getUTCMonth();
  if (preset === 'this-month')
    return { from: day(new Date(Date.UTC(year, month, 1))), to: day(today) };
  if (preset === 'last-month') {
    return {
      from: day(new Date(Date.UTC(year, month - 1, 1))),
      to: day(new Date(Date.UTC(year, month, 0))),
    };
  }
  const days = Number(preset);
  return { from: day(new Date(today.getTime() - (days - 1) * DAY_MS)), to: day(today) };
}

export function DateRangePicker(props: { value: DayRange; onChange: (range: DayRange) => void }) {
  const [preset, setPreset] = useState<Preset>('this-month');
  const [custom, setCustom] = useState(props.value);
  return (
    <div className="row wrap inline-form filters">
      <label>
        Range
        <select
          value={preset}
          onChange={(event) => {
            const next = event.target.value as Preset;
            setPreset(next);
            if (next === 'custom') setCustom(props.value);
            else props.onChange(presetRange(next));
          }}
        >
          {PRESETS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      {preset === 'custom' && (
        <form
          className="row wrap"
          onSubmit={(event) => {
            event.preventDefault();
            props.onChange(custom);
          }}
        >
          <label>
            From
            <input
              type="date"
              required
              value={custom.from}
              max={custom.to}
              onChange={(e) => setCustom({ ...custom, from: e.target.value })}
            />
          </label>
          <label>
            To
            <input
              type="date"
              required
              value={custom.to}
              min={custom.from}
              onChange={(e) => setCustom({ ...custom, to: e.target.value })}
            />
          </label>
          <button type="submit">Show</button>
        </form>
      )}
      <span className="hint">Days in UTC.</span>
    </div>
  );
}
